import { useRef } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import StoreProductCard from "./StoreProductCard";

const StoreProductCarousel = ({ title, eyebrow, description, products, emptyMessage }) => {
  const carouselRef = useRef(null);

  const scrollProducts = (direction) => {
    if (!carouselRef.current) return;

    const cardWidth = carouselRef.current.clientWidth * 0.82;
    carouselRef.current.scrollBy({
      left: direction === "next" ? cardWidth : -cardWidth,
      behavior: "smooth",
    });
  };

  return (
    <section className="store-section-card">
      <div className="store-section-header">
        <div>
          <span className="store-section-eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>

        <div className="store-carousel-actions">
          <button
            type="button"
            className="store-carousel-arrow"
            onClick={() => scrollProducts("prev")}
            aria-label={`Voltar em ${title}`}
          >
            <FiChevronLeft />
          </button>
          <button
            type="button"
            className="store-carousel-arrow"
            onClick={() => scrollProducts("next")}
            aria-label={`Avançar em ${title}`}
          >
            <FiChevronRight />
          </button>
        </div>
      </div>

      {products.length > 0 ? (
        <div className="store-carousel" ref={carouselRef}>
          {products.map((product) => (
            <div className="store-carousel-slide" key={product.id}>
              <StoreProductCard product={product} variant="carousel" />
            </div>
          ))}
        </div>
      ) : (
        <div className="store-empty-state">{emptyMessage}</div>
      )}
    </section>
  );
};

export default StoreProductCarousel;
